/**
 * PaymentsTab — вкладка «Платежи» карточки: последние продления или пустое
 * состояние (клиент в триале). Ссылка «Все платежи» ведёт в общий журнал.
 */

import dayjs from 'dayjs';
import {CreditCard} from 'lucide-react';

import type {ClientDetail, ClientListItem} from '@services/clients';
import {formatNumber} from '@utils/format';

const STATUS_LABEL: Record<
  ClientDetail['payments'][number]['status'],
  {text: string; cls: string}
> = {
  success: {text: 'Успешно', cls: 'text-skr-paid'},
  failed: {text: 'Неудачно', cls: 'text-skr-danger'},
  refunded: {text: 'Возврат', cls: 'text-muted-foreground'},
};

type PaymentsTabProps = {detail: ClientDetail; client: ClientListItem};

export const PaymentsTab = ({detail, client}: PaymentsTabProps) => {
  if (detail.payments.length === 0) {
    return (
      <div className="flex flex-col items-center px-5 py-[46px] text-center">
        <div className="mb-3.5 grid size-[52px] place-items-center rounded-[14px] bg-[#F0F1F4] text-skr-faint">
          <CreditCard className="size-[26px]" strokeWidth={1.7} />
        </div>
        <div className="text-sm font-semibold">Платежей пока нет</div>
        <div className="mt-1 max-w-[280px] text-[12.5px] leading-[1.5] text-muted-foreground">
          Клиент в триале — первое списание {client.type === 'solo' ? '1 200 сом ' : ''}пройдёт при
          активации подписки.
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="overflow-hidden rounded-[13px] border border-skr-line bg-card">
        {detail.payments.map((p, i) => {
          const s = STATUS_LABEL[p.status];
          return (
            <div
              key={p.id}
              className={`flex items-center justify-between px-4 py-[13px] ${i < detail.payments.length - 1 ? 'border-b border-skr-hairline' : ''}`}
            >
              <div>
                <div className="text-[13.5px] font-medium">{p.label}</div>
                <div className="font-mono text-xs text-muted-foreground">
                  {dayjs(p.date).format('D MMM YYYY').replace('.', '')}
                </div>
              </div>
              <div className="text-right">
                <div className="font-mono font-semibold">{formatNumber(p.amount)}</div>
                <span className={`text-[11.5px] font-semibold ${s.cls}`}>{s.text}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
